import { useEmbarcacaoComercial } from "../../../../hooks/use-embarcacao-comercial";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  COMERCIAL_EMPTY_STATE,
  COMERCIAL_FIELDS,
  COMERCIAL_ID,
  COMERCIAL_LOADING_MESSAGE,
  COMERCIAL_TEST_ID,
  COMERCIAL_TITLE,
} from "./comercial-section.constants";

/** Seção Comercial do detalhamento da embarcação, somente para consulta: campos já formatados na ordem da tela; campo sem valor mostra "Campo sem preenchimento". */
export function useComercialSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, comercial, errorMessage, reload } = useEmbarcacaoComercial(embarcacaoId);

  return {
    id: COMERCIAL_ID,
    title: COMERCIAL_TITLE,
    testId: COMERCIAL_TEST_ID,
    fieldsTestId: `${COMERCIAL_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: COMERCIAL_LOADING_MESSAGE,
    emptyContent: COMERCIAL_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: comercial
      ? latestAtualizacao([comercial.ultimaAtualizacao, comercial.atualizacaoComercial])
      : undefined,
    fields: buildDetailFields(
      comercial,
      COMERCIAL_FIELDS,
      COMERCIAL_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
